import React from "react";

/**
 * Light shared framing for onboarding steps (title + supporting line).
 */
export default function OnboardingStepFrame({ title, subtitle, children, wide = false }) {
  return (
    <div className={wide ? "w-full" : "max-w-3xl"}>
      {(title || subtitle) && (
        <header className="mb-6">
          {title ? (
            <h1 className="text-2xl font-semibold tracking-tight text-gray-900 sm:text-[1.65rem]">
              {title}
            </h1>
          ) : null}
          {subtitle ? (
            <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-gray-600">{subtitle}</p>
          ) : null}
        </header>
      )}
      {children}
    </div>
  );
}
